// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lblvalue {\n  padding: 2px 8px !important;\n  height: 100% !important;\n  word-wrap: break-word;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.3);\n  overflow-y: auto;\n  font-size: 1.05em;\n}\n.lbltitle {\n  font-size: 0.8rem !important;\n}\n.lblIcon {\n  font-size: 0.7rem !important;\n  margin-right: 4px;\n  font-weight: 600;\n}", ""]);
// Exports
module.exports = exports;
